import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./styles/Quoting.css";

const Quoting = () => {
  const { t } = useTranslation();

  const [cyclists, setCyclists] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [selectedCyclistList, setSelectedCyclistList] = useState(1);

  const handleButtonClick = (buttonName) => {
    setSelectedCyclistList(buttonName);
  };

  useEffect(() => {
    const fetchCyclists = async () => {
      try {
        const response = await fetch(`${apiUrl}/cyclists-list/0`);
        if (!response.ok) {
          throw new Error(t("quoting.errors.fetchCyclists"));
        }
        const data = await response.json();
        setCyclists(data);
      } catch (error) {
        console.error("Erreur:", error);
      }
    };

    fetchCyclists();
  }, [apiUrl, t]);

  return (
    <main className="quoting">
      <h1>{t("quoting.title")}</h1>

      <div className="quoting-choice">
        <button
          onClick={() => handleButtonClick(1)}
          style={{ backgroundColor: selectedCyclistList === 1 ? "#007afd" : "#0056b3" }}
        >
          {t("quoting.groups.worldTour")}
        </button>

        <button
          onClick={() => handleButtonClick(2)}
          style={{ backgroundColor: selectedCyclistList === 2 ? "#007afd" : "#0056b3" }}
        >
          {t("quoting.groups.neoPro")}
        </button>
      </div>

      <div className="quoting-table">
        <div className="quoting-table-container">
          <table>
            <thead>
              <tr>
                <th>{t("quoting.table.rider")}</th>
                <th>{t("quoting.table.team")}</th>
                <th>{t("quoting.table.value")}</th>
                <th>{t("quoting.table.speciality")}</th>
              </tr>
            </thead>

            <tbody>
              {cyclists
                .filter((cyclist) => cyclist.cyclistGroupId === selectedCyclistList)
                .map((cyclist, index) => (
                  <tr key={index}>
                    <td>
                      <div className="quoting-name-container">
                        <img
                          className="quoting-flag-icon"
                          src={`${process.env.PUBLIC_URL}/flags/${cyclist.nationality
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .replace(/ /g, "_")
                            .toLowerCase()}.png`}
                          alt={t("quoting.flagAlt", { nationality: cyclist.nationality })}
                          width="20"
                          height="20"
                        />
                        <span>{cyclist.name}</span>
                      </div>
                    </td>
                    <td>{cyclist.team}</td>
                    <td>{cyclist.finalValue}</td>
                    <td>{cyclist.speciality}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
};

export default Quoting;
